import * as React from 'react';
import { useMemo } from 'react';

import { ResponsiveFrame } from './ResponsiveFrame';

export interface ResponsiveImageFrameProps {
  innerRef?: React.Ref<HTMLDivElement>;
  image: HTMLImageElement;
}

export const ResponsiveImageFrame = ({ innerRef, image }: ResponsiveImageFrameProps) => {
  const aspectRatio = useMemo(() => measureAspectRatio(image), [image]);

  return <ResponsiveFrame aspectRatio={aspectRatio} innerRef={innerRef} />;
};

function measureAspectRatio(image: HTMLImageElement) {
  if (image.naturalWidth && image.naturalHeight) {
    return image.naturalWidth / image.naturalHeight;
  }

  // Firefox does not report natural dimensions for SVG images, so let's measure
  // them in an offscreen container:
  const div = document.createElement('div');

  div.style.left = '-9999px';
  div.style.position = 'fixed';
  div.style.top = '-9999px';
  div.style.width = '100px';

  div.appendChild(image);
  document.body.appendChild(div);

  const ratio = div.offsetWidth / div.offsetHeight;

  document.body.removeChild(div);
  div.removeChild(image);

  return ratio;
}
